import _ from 'lodash';

export default function orderGasMeterObject() {
  return (input, attribute) => {
    if (!_.isObject(input)) {
      return input;
    }
    const array = _.values(input);

    // supports either attr:value or attr:Object format
    array.sort((first, second) => {
      // if x && y javascript returns y
      first = parseFloat((first[attribute] && first[attribute].value) || first[attribute]);
      second = parseFloat((second[attribute] && second[attribute].value) || second[attribute]);
      if (!first && !second) {
        return 0;
      }
      if (!first) { // if not defined: alway last
        return 1;
      }
      if (!second) {
        return -1;
      }
      return first - second;
    });
    return array;
  };
}
